import { render, staticRenderFns } from "./company-and-freezer-add-or-update.vue?vue&type=template&id=609fa8a3&scoped=true&"
import script from "./company-and-freezer-add-or-update.vue?vue&type=script&lang=js&"
export * from "./company-and-freezer-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./company-and-freezer-add-or-update.vue?vue&type=style&index=0&id=609fa8a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609fa8a3",
  null
  
)

export default component.exports